var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDeviceDesktop = function SvgDeviceDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 763.3 659.8",
    style: {
      enableBackground: "new 0 0 763.3 659.8"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M737.448-.024H25.851C11.568-.024-.024 11.568-.024 25.851v517.5c0 14.283 11.592 25.875 25.875 25.875h252.264c0 28.566-23.184 51.75-51.75 51.75v38.778h310.5v-38.778c-28.566 0-51.75-23.184-51.75-51.75h252.264c14.283 0 25.875-11.592 25.875-25.875v-517.5c.069-14.283-11.523-25.875-25.806-25.875zM362.226 511.059c0-10.695 8.694-19.389 19.389-19.389s19.389 8.694 19.389 19.389-8.694 19.389-19.389 19.389-19.389-8.694-19.389-19.389zM38.823 452.823v-414h685.722v414H38.823z"
  })));
};

export default SvgDeviceDesktop;